import { apiServiceClient } from '../frameworkClient';

const adminServiceClient = apiServiceClient(
  process.env.REACT_APP_ADMIN_URL || 'framework/AdminService',
);

const endpoints = {
  blockUser: 'blockUser',
  changeContractToSwap: 'changeContractToSwap',
  changeTestContractStage: 'changeTestContractStage',
  createCampaign: 'createCampaign',
  createCampaignAction: 'createCampaignAction',
  createCohortRule: 'createCohortRule',
  createStore: 'createStore',
  createTestContract: 'createTestContract',
  createUpgradeOffer: 'createUpgradeOffer',
  createUpgradeOfferRule: 'createUpgradeOfferRule',
  createUser: 'createUser',
  createWlDevice: 'createWlDevice',
  deleteCampaign: 'deleteCampaign',
  deleteCohortRule: 'deleteCohortRule',
  deleteCommunication: 'deleteCommunication',
  deleteHtmlBlock: 'deleteHtmlBlock',
  deleteTestContract: 'deleteTestContract',
  deleteUpgradeOffer: 'deleteUpgradeOffer',
  deleteUpgradeOfferRule: 'deleteUpgradeOfferRule',
  disableWlDevice: 'disableWlDevice',
  expireTestContractDelay: 'expireTestContractDelay',
  getAllCampaigns: 'getAllCampaigns',
  getCampaign: 'getCampaign',
  getCampaignCohorts: 'getCampaignCohorts',
  getCampaignFormData: 'getCampaignFormData',
  getCampaignMessages: 'getCampaignMessages',
  getCampaignOffers: 'getCampaignOffers',
  getCrmTestContracts: 'getCrmTestContracts',
  getOffersFormData: 'getOffersFormData',
  getTestContract: 'getTestContract',
  getTestContractFormData: 'getTestContractFormData',
  getUser: 'getUser',
  getVouchers: 'getVouchers',
  listAccessories: 'listAccessories',
  listDevices: 'listDevices',
  listHtmlBlocks: 'listHtmlBlocks',
  listStores: 'listStores',
  listTemplateHelpers: 'listTemplateHelpers',
  listTemplateHtmlBlocks: 'listTemplateHtmlBlocks',
  listUsers: 'listUsers',
  listTemplatePlaceholders: 'listTemplatePlaceholders',
  publishTemplate: 'publishTemplate',
  readHtmlBlock: 'readHtmlBlock',
  readTemplate: 'readTemplate',
  renderEmail: 'renderEmail',
  resetUserPassword: 'resetUserPassword',
  saveHtmlBlock: 'saveHtmlBlock',
  saveTemplate: 'saveTemplate',
  sendEmail: 'sendEmail',
  sendSMS: 'sendSMS',
  unblockUser: 'unblockUser',
  updateCampaign: 'updateCampaign',
  updateCampaignAction: 'updateCampaignAction',
  updateCohortRule: 'updateCohortRule',
  updateStore: 'updateStore',
  updateUser: 'updateUser',
  updateWlDevice: 'updateWlDevice',
  updateUpgradeOffer: 'updateUpgradeOffer',
  updateUpgradeOfferRule: 'updateUpgradeOfferRule',
  uploadFile: 'uploadFile',
};

export const blockUser = async ({ userID, sessionID }, options) => {
  return adminServiceClient(
    endpoints.blockUser,
    { userID, sessionID },
    options,
  );
};

export const changeContractToSwap = async (
  { swapStatus, uuids, sessionID },
  options,
) => {
  return await adminServiceClient(
    endpoints.changeContractToSwap,
    {
      swapStatus,
      uuids,
      sessionID,
    },
    options,
  );
};

export const changeTestContractStage = async (
  { id, stage, sessionID },
  options,
) => {
  return await adminServiceClient(
    endpoints.changeTestContractStage,
    {
      id,
      stage,
      sessionID,
    },
    options,
  );
};

export const createCampaign = async ({ campaign, sessionID }, options) => {
  return adminServiceClient(
    endpoints.createCampaign,
    { campaign, sessionID },
    options,
  );
};

export const createCampaignAction = async (
  { campaignAction, sessionID },
  options,
) => {
  return adminServiceClient(
    endpoints.createCampaignAction,
    { campaignAction, sessionID },
    options,
  );
};

export const createCohortRule = async ({ cohortRule, sessionID }, options) => {
  return adminServiceClient(
    endpoints.createCohortRule,
    { cohortRule, sessionID },
    options,
  );
};

export const createStore = async ({ store, sessionID }, options) => {
  return adminServiceClient(
    endpoints.createStore,
    { store, sessionID },
    options,
  );
};

export const createTestContract = async (
  { contractID, testContract, sessionID },
  options,
) => {
  return adminServiceClient(
    endpoints.createTestContract,
    { contractID, testContract, sessionID },
    options,
  );
};

export const createUpgradeOffer = async ({ offer, sessionID }, options) => {
  return adminServiceClient(
    endpoints.createUpgradeOffer,
    { offer, sessionID },
    options,
  );
};

export const createUpgradeOfferRule = async (
  { offerRule, sessionID },
  options,
) => {
  return adminServiceClient(
    endpoints.createUpgradeOfferRule,
    { offerRule, sessionID },
    options,
  );
};

export const createUser = async ({ user, sessionID }, options) => {
  return adminServiceClient(endpoints.createUser, { user, sessionID }, options);
};

export const createWlDevice = async ({ wlDevice, sessionID }, options) => {
  await adminServiceClient(
    endpoints.createWlDevice,
    { wlDevice, sessionID },
    options,
  );

  return listDevices({ sessionID });
};

export const deleteCampaign = async ({ campaignCode, sessionID }, options) => {
  return adminServiceClient(
    endpoints.deleteCampaign,
    { campaignCode, sessionID },
    options,
  );
};

export const deleteCommunication = async (
  { campaignCode, id, sessionID },
  options,
) => {
  return adminServiceClient(
    endpoints.deleteCommunication,
    { campaignCode, id, sessionID },
    options,
  );
};

export const deleteHtmlBlock = async ({ uuid, sessionID }, options) => {
  return adminServiceClient(
    endpoints.deleteHtmlBlock,
    { uuid, sessionID },
    options,
  );
};

export const deleteTestContract = async ({ id, sessionID }, options) => {
  return adminServiceClient(
    endpoints.deleteTestContract,
    { id, sessionID },
    options,
  );
};

export const deleteCohortRule = async (
  { campaignCode, id, sessionID },
  options,
) => {
  return adminServiceClient(
    endpoints.deleteCohortRule,
    {
      campaignCode,
      id,
      sessionID,
    },
    options,
  );
};

export const disableWlDevice = async ({ wlDeviceID, sessionID }, options) => {
  await adminServiceClient(
    endpoints.disableWlDevice,
    {
      wlDeviceID,
      sessionID,
    },
    options,
  );

  return listDevices({ sessionID });
};

export const expireTestContractDelay = async ({ id, sessionID }, options) => {
  return adminServiceClient(
    endpoints.expireTestContractDelay,
    { id, sessionID },
    options,
  );
};

export const deleteUpgradeOffer = async ({ offer, sessionID }, options) => {
  return adminServiceClient(
    endpoints.deleteUpgradeOffer,
    {
      offer,
      sessionID,
    },
    options,
  );
};

export const deleteUpgradeOfferRule = async (
  { offerRule, sessionID },
  options,
) => {
  return adminServiceClient(
    endpoints.deleteUpgradeOfferRule,
    {
      offerRule,
      sessionID,
    },
    options,
  );
};

export const getAllCampaigns = async ({ sessionID }, options) => {
  return adminServiceClient(
    endpoints.getAllCampaigns,
    {
      sessionID,
    },
    options,
  );
};

export const getCampaign = async ({ campaignCode, sessionID }, options) => {
  return adminServiceClient(
    endpoints.getCampaign,
    {
      campaignCode,
      sessionID,
    },
    options,
  );
};

export const getCampaignCohorts = async (
  { campaignCode, sessionID },
  options,
) => {
  return adminServiceClient(
    endpoints.getCampaignCohorts,
    {
      campaignCode,
      sessionID,
    },
    options,
  );
};

export const getCampaignFormData = async (
  { category, manufacturer, family, sessionID },
  options,
) => {
  return adminServiceClient(
    endpoints.getCampaignFormData,
    {
      category,
      manufacturer,
      family,
      sessionID,
    },
    options,
  );
};

export const getCampaignMessages = async (
  { campaignCode, sessionID },
  options,
) => {
  return adminServiceClient(
    endpoints.getCampaignMessages,
    {
      campaignCode,
      sessionID,
    },
    options,
  );
};

export const getCampaignOffers = async (
  { campaignCode, sessionID },
  options,
) => {
  return adminServiceClient(
    endpoints.getCampaignOffers,
    {
      campaignCode,
      sessionID,
    },
    options,
  );
};

export const getCrmTestContracts = async ({ sessionID }, options) => {
  return adminServiceClient(
    endpoints.getCrmTestContracts,
    { sessionID },
    options,
  );
};

export const getOffersFormData = async (
  { category, manufacturer, family, sessionID },
  options,
) => {
  return adminServiceClient(
    endpoints.getOffersFormData,
    {
      category,
      manufacturer,
      family,
      sessionID,
    },
    options,
  );
};

export const getTestContract = async ({ id, sessionID }, options) => {
  return adminServiceClient(
    endpoints.getTestContract,
    { id, sessionID },
    options,
  );
};

export const getTestContractFormData = async ({ sessionID }, options) => {
  return adminServiceClient(
    endpoints.getTestContractFormData,
    {
      sessionID,
    },
    options,
  );
};

export const getUser = async ({ userID, sessionID }, options) => {
  return adminServiceClient(endpoints.getUser, { userID, sessionID }, options);
};

export const getVouchers = async ({ sessionID }, options) => {
  return adminServiceClient(endpoints.getVouchers, { sessionID }, options);
};

export const listAccessories = async ({ sessionID }, options) => {
  return adminServiceClient(endpoints.listAccessories, { sessionID }, options);
};

export const listDevices = async ({ sessionID }, options) => {
  return adminServiceClient(endpoints.listDevices, { sessionID }, options);
};

export const listHtmlBlocks = async ({ sessionID }, options) => {
  return adminServiceClient(endpoints.listHtmlBlocks, { sessionID }, options);
};

export const listStores = async ({ wlID, sessionID }, options) => {
  return adminServiceClient(endpoints.listStores, { wlID, sessionID }, options);
};

export const listTemplateHelpers = async ({ sessionID }, options) =>
  adminServiceClient(endpoints.listTemplateHelpers, { sessionID }, options);

export const listUsers = async ({ sessionID }, options) => {
  return adminServiceClient(endpoints.listUsers, { sessionID }, options);
};

export const listTemplatePlaceholders = async ({ sessionID }, options) =>
  adminServiceClient(
    endpoints.listTemplatePlaceholders,
    { sessionID },
    options,
  );
export const listTemplateHtmlBlocks = async ({ sessionID }, options) => {
  return adminServiceClient(
    endpoints.listTemplateHtmlBlocks,
    { sessionID },
    options,
  );
};

export const publishTemplate = async (
  { campaignCode, templateName, sessionID },
  options,
) => {
  return adminServiceClient(
    endpoints.publishTemplate,
    { campaignCode, templateName, sessionID },
    options,
  );
};

export const readHtmlBlock = async ({ uuid, sessionID }, options) => {
  return adminServiceClient(
    endpoints.readHtmlBlock,
    { uuid, sessionID },
    options,
  );
};

export const readTemplate = async (
  { campaignCode, templateName, sessionID },
  options,
) => {
  return adminServiceClient(
    endpoints.readTemplate,
    { campaignCode, templateName, sessionID },
    options,
  );
};

export const renderEmail = async (
  {
    campaignCode,
    contractReference,
    htmlPart,
    subject,
    templateName,
    sessionID,
  },
  options,
) => {
  return adminServiceClient(
    endpoints.renderEmail,
    {
      campaignCode,
      contractReference,
      htmlPart,
      subject,
      templateName,
      sessionID,
    },
    options,
  );
};

export const resetUserPassword = async ({ userID, sessionID }, options) => {
  return adminServiceClient(
    endpoints.resetUserPassword,
    { userID, sessionID },
    options,
  );
};

export const saveHtmlBlock = async ({ htmlBlock, sessionID }, options) => {
  return adminServiceClient(
    endpoints.saveHtmlBlock,
    { htmlBlock, sessionID },
    options,
  );
};

export const saveTemplate = async ({ template, sessionID }, options) => {
  return adminServiceClient(
    endpoints.saveTemplate,
    { template, sessionID },
    options,
  );
};

export const sendEmail = async (
  { from, to, contractReference, templateKey, sessionID },
  options,
) => {
  return adminServiceClient(
    endpoints.sendEmail,
    { from, to, contractReference, templateKey, sessionID },
    options,
  );
};

export const sendSMS = async (
  { phone, contractReference, templateKey, sessionID },
  options,
) => {
  return adminServiceClient(
    endpoints.sendSMS,
    { phone, contractReference, templateKey, sessionID },
    options,
  );
};

export const unblockUser = async ({ userID, sessionID }, options) => {
  return adminServiceClient(
    endpoints.unblockUser,
    { userID, sessionID },
    options,
  );
};

export const updateCampaign = async ({ campaign, sessionID }, options) => {
  return adminServiceClient(
    endpoints.updateCampaign,
    { campaign, sessionID },
    options,
  );
};

export const updateCampaignAction = async (
  { campaignAction, sessionID },
  options,
) => {
  return adminServiceClient(
    endpoints.updateCampaignAction,
    { campaignAction, sessionID },
    options,
  );
};

export const updateCohortRule = async ({ cohortRule, sessionID }, options) => {
  return adminServiceClient(
    endpoints.updateCohortRule,
    { cohortRule, sessionID },
    options,
  );
};

export const updateStore = async ({ store, sessionID }, options) => {
  return adminServiceClient(
    endpoints.updateStore,
    { store, sessionID },
    options,
  );
};

export const updateUser = async ({ user, sessionID }, options) => {
  return adminServiceClient(endpoints.updateUser, { user, sessionID }, options);
};

export const updateWlDevice = async ({ wlDevice, sessionID }, options) => {
  await adminServiceClient(
    endpoints.updateWlDevice,
    { wlDevice, sessionID },
    options,
  );
  return listDevices({ sessionID });
};

export const uploadFile = async (
  { file, type, campaignCode, sessionID },
  options,
) => {
  return adminServiceClient(
    endpoints.uploadFile,
    {
      file,
      type,
      campaignCode,
      sessionID,
    },
    options,
  );
};

export const updateUpgradeOffer = async ({ offer, sessionID }, options) => {
  return adminServiceClient(
    endpoints.updateUpgradeOffer,
    {
      offer,
      sessionID,
    },
    options,
  );
};

export const updateUpgradeOfferRule = async (
  { offerRule, sessionID },
  options,
) => {
  return adminServiceClient(
    endpoints.updateUpgradeOfferRule,
    {
      offerRule,
      sessionID,
    },
    options,
  );
};

export default {
  blockUser,
  changeContractToSwap,
  changeTestContractStage,
  createCampaign,
  createCampaignAction,
  createCohortRule,
  createStore,
  createTestContract,
  createUser,
  createUpgradeOffer,
  createUpgradeOfferRule,
  createWlDevice,
  deleteCampaign,
  deleteCommunication,
  deleteHtmlBlock,
  deleteTestContract,
  deleteCohortRule,
  deleteUpgradeOffer,
  deleteUpgradeOfferRule,
  disableWlDevice,
  expireTestContractDelay,
  endpoints,
  getAllCampaigns,
  getCampaign,
  getCampaignFormData,
  getCampaignCohorts,
  getCampaignFormData,
  getCampaignMessages,
  getCampaignOffers,
  getOffersFormData,
  getCrmTestContracts,
  getTestContract,
  getTestContractFormData,
  getUser,
  getVouchers,
  listAccessories,
  listDevices,
  listHtmlBlocks,
  listStores,
  listTemplateHelpers,
  listTemplateHtmlBlocks,
  listUsers,
  listTemplatePlaceholders,
  publishTemplate,
  readHtmlBlock,
  readTemplate,
  renderEmail,
  resetUserPassword,
  saveHtmlBlock,
  saveTemplate,
  sendEmail,
  sendSMS,
  unblockUser,
  updateCampaign,
  updateCampaignAction,
  updateCohortRule,
  updateStore,
  updateUser,
  updateWlDevice,
  uploadFile,
  updateUpgradeOffer,
  updateUpgradeOfferRule,
};
